
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Importacao() {
  const [selectedService, setSelectedService] = useState('');

  const importServices = [
    {
      id: 'express',
      name: 'Express',
      description: 'Compras urgentes com frete aéreo',
      icon: 'ri-plane-line'
    },
    {
      id: 'standard',
      name: 'Padrão',
      description: 'Melhor custo-benefício',
      icon: 'ri-ship-line'
    },
    {
      id: 'bulk',
      name: 'Por Lote',
      description: 'Para grandes quantidades com melhor preço',
      icon: 'ri-truck-line'
    }
  ];

  const importProcess = [
    {
      step: 1,
      title: 'Consulta Inicial',
      description: 'Envie os detalhes do produto que você precisa',
      icon: 'ri-search-line'
    },
    {
      step: 2,
      title: 'Cotação',
      description: 'Pesquisamos fornecedores e enviamos orçamento detalhado',
      icon: 'ri-file-list-line'
    },
    {
      step: 3,
      title: 'Aprovação',
      description: 'Você aprova o orçamento e fazemos o pedido',
      icon: 'ri-checkbox-circle-line'
    },
    {
      step: 4,
      title: 'Importação',
      description: 'Cuidamos de toda a logística e documentação',
      icon: 'ri-global-line'
    },
    {
      step: 5,
      title: 'Entrega',
      description: 'Receba o seu pedido com garantia e suporte técnico',
      icon: 'ri-truck-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat min-h-[500px] flex items-center"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(20, 184, 166, 0.8), rgba(6, 78, 59, 0.9)), url('/images/importacao-hero.jpg')`,
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Importação de peças e acessórios sob encomenda
            </h1>
            <p className="text-xl text-gray-200 mb-8">
              O lugar certo para encontrar o que falta no seu projeto. Acesso exclusivo a fornecedores globais, com segurança, agilidade e ótimo custo-benefício.
            </p>
            <Link
              to="/contato"
              className="bg-teal-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-teal-700 transition-colors inline-block whitespace-nowrap cursor-pointer"
            >
              Solicitar Cotação
            </Link>
          </div>
        </div>
      </section>

      {/* Tipos de Importação */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Tipos de Importação</h2>
            <p className="text-lg text-gray-600">Escolha o serviço que melhor atende suas necessidades</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {importServices.map((service) => (
              <div 
                key={service.id}
                className={`bg-white border-2 rounded-lg p-6 cursor-pointer transition-all hover:shadow-lg ${
                  selectedService === service.id ? 'border-teal-500 shadow-lg' : 'border-gray-200'
                }`}
                onClick={() => setSelectedService(service.id)}
              >
                <div className="text-center mb-6">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${service.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processo de Importação */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Como Funciona o Processo</h2>
            <p className="text-lg text-gray-600">Simples, rápido e seguro</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
            {importProcess.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600 text-sm">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vantagens */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Por que importar com a GZ?</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Garantia Total</h3>
              <p className="text-gray-600">Todas as peças possuem garantia e suporte técnico completo.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-file-text-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Documentação Completa</h3>
              <p className="text-gray-600">Cuidamos de toda a documentação alfandegária e certificações necessárias.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-eye-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Rastreamento Total</h3>
              <p className="text-gray-600">Acompanhe sua encomenda desde o fornecedor até a entrega final.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Preços Competitivos</h3>
              <p className="text-gray-600">Negociamos diretamente com fornecedores para obter os melhores preços.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-time-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Prazos Confiáveis</h3>
              <p className="text-gray-600">Experiência de anos garante prazos realistas e cumprimento das entregas.</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-customer-service-2-line text-2xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Suporte Especializado</h3>
              <p className="text-gray-600">Equipe técnica especializada para orientar na escolha das peças corretas.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Pronto para fazer o seu pedido?</h2>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e receba uma cotação personalizada
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contato"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Solicitar Cotação
            </Link>
            <Link
              to="/contato"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Falar com Especialista
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
